module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-06.29310397.jpg";